import { render, staticRenderFns } from "./addDealer.vue?vue&type=template&id=6687f48a&scoped=true&"
import script from "./addDealer.vue?vue&type=script&lang=js&"
export * from "./addDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687f48a",
  null
  
)

export default component.exports